import { Link } from "react-router-dom";
import { useAppContext } from "../../context/AppContext.jsx";

function SidebarMinifyBtn() {
  const { toggleAppSidebarMinify } = useAppContext();

  return (
    <div className="menu">
      <div className="menu-item d-flex">
        <Link
          to="/"
          className="app-sidebar-minify-btn ms-auto"
          onClick={toggleAppSidebarMinify}
        >
          <i className="fa fa-angle-double-left"></i>
        </Link>
      </div>
    </div>
  );
}

export default SidebarMinifyBtn;
